"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _useStyles = _interopRequireDefault(require("../useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var List = function List(_ref) {
  var underline = _ref.underline,
      listItemText = _ref.listItemText,
      onClick = _ref.onClick;
  var classes = (0, _useStyles["default"])({
    underline: underline
  });
  return onClick ? /*#__PURE__*/_react["default"].createElement("li", {
    className: classes.list
  }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    onClick: onClick,
    button: true,
    className: classes.listButton
  }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: listItemText
  }))) : /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    component: "li",
    className: classes.list
  }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: listItemText
  }));
};

List.defaultProps = {
  underline: false,
  onClick: undefined
};
List.propTypes = {
  underline: _propTypes["default"].bool,
  listItemText: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func
};
var _default = List;
exports["default"] = _default;